/* Built In Imports */
import { useContext, useEffect, useRef, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import CardFilter from '@components/Filters/CardFilter';
import Breadcrum from '@components/Navigation/Breadcrum';
import MeetSadhguru from '@components/Sliders/MeetSadhguru';
import AboutContainer from '@components/UI/AboutContainer';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import SadhguruBanner from '@HeaderBanner/SadhguruBanner';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import {
  fetchSadhguruPageData,
  getSadhguruLandingPaths,
} from 'services/sadhguruService';

/* Styles */
import classes from '@styles/pages/SadhguruPage.module.css';

/**
 *
 * @param region
 * @param language
 * @param pageData
 */
const Sadhguru = ({ region, language, pageData }) => {
  // const [currentUserRegion, setCurrentUserRegion] = useState(region);
  const [filterOptions, setfilterOptions] = useState([
    'Man',
    'Mission',
    'Mystic',
  ]);

  const authContext = useContext(AuthContext);
  const myRef = useRef(null);

  useEffect(() => {
    // const currentRegion = config.locales.find(
    //   locale => locale.region_sf === region
    // ).region;
    authContext.RegionAndLang(region, language);
    // setCurrentUserRegion(currentRegion);
    const currentUrl = window.location.hash;
    if (myRef && currentUrl?.indexOf('#meet-sadhguru') >= 0) {
      myRef?.current?.scrollIntoView();
    }
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url={pageData.url}
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box maxWidth="1300px" m="0 auto" float="none" data-gri>
        <Box bg={'floralWhite.100'} w="100%" float="left">
          <SadhguruBanner
            title={pageData.bannerSection && pageData.bannerSection[0].title}
            desc={pageData.bannerSection && pageData.bannerSection[0].body}
            bannerImg={
              pageData.bannerSection &&
              pageData.bannerSection[0].mobileBannerImage.url
            }
            videoLink={
              pageData.bannerSection && pageData.bannerSection[0].videoLink
            }
          />
          <Box
            pos="relative"
            w="100%"
            float="left"
            _before={{
              bgImage: `${config.imgPath}/d/46272/1663649782-mystic-top.png`,
              content: '" "',
              left: 0,
              top: 0,
              height: '537px',
              pos: 'absolute',
              width: '103px',
              opacity: '0.5',
            }}
            _
            _after={{
              bgImg: `${config.imgPath}/d/46272/1663654737-mystic-bottom.png`,
              content: '" "',
              right: 0,
              height: '537px',
              pos: 'absolute',
              width: '103px',
              opacity: '0.5',
            }}
          >
            <AboutContainer sectionData={pageData.sections} />
          </Box>
          <Box className={classes['about-sadhguru']}>
            <Box className={classes['isha-wrap']}>
              <Box
                fontFamily="FedraSansStd-A-medium,sans-serif"
                fontSize="30px"
                fontWeight="500"
                textAlign="center"
                color="#28231e"
                float="left"
                w="100%"
                lineHeight="1.13"
                pt="50px"
                p="16px"
              >
                {pageData.moreThanLifeTitle}
              </Box>
              <Box float="left" w="100%" textAlign="center" pb="40px" pt="20px">
                <LazyLoadImageComponent
                  alt="divider"
                  src={`${config.staticPath}/assets/images/snake-divider.svg`}
                />
              </Box>
              <Box
                fontFamily="FedraSansStd-book"
                lineHeight="1.7"
                textAlign="left"
                fontSize="18px"
                color="#28231e"
                w={{
                  base: '100%',
                  sm: '100%',
                  md: '100%',
                  lg: '60%',
                }}
                margin="0 auto"
                p="0px 16px 50px 16px"
              >
                {pageData.moreThanLifeBody && parser(pageData.moreThanLifeBody)}
              </Box>
            </Box>
          </Box>
          <Box float="left" w="100%" mb="40px">
            <CardFilter
              posts={pageData.posts}
              mmmSection="all"
              contentTypes={filterOptions}
              page="sadhguru"
              region={region}
              lang={language}
            />
          </Box>
          <Box float="left" w="100%">
            {pageData.meet_sadhguru?.results != 0 ? (
              <MeetSadhguru
                meetData={
                  pageData?.meet_sadhguru && pageData?.meet_sadhguru?.results
                }
                myRef={myRef}
              />
            ) : (
              ''
            )}
          </Box>
        </Box>
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const sadhguruLandingPath = config.USE_LOCAL_URL
    ? [`/en/sadhguru`]
    : await getSadhguruLandingPaths('lvl0', '/sadhguru', [
        '/sadhguru-exclusive',
        '/sadhguru-exclusive-free-trial',
        '/sadhguru-radio',
        '/sadhguru-app',
        '/sadhguru-school-uganda',
        '/sadhguru-gurukulam',
        '/sadhguru-in-australia',
        '/sadhguru-publications',
        '/sadhguru-schedule',
      ]);
  // consoleLog('sadhguruLandingPath', sadhguruLandingPath);
  return {
    paths: sadhguruLandingPath,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region },
  req,
}) => {
  // const ipRegion = await getCurrentIpRegion();
  const language = region;

  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  // console.log('getLocale', getLocale('', language));
  const pageData = await fetchSadhguruPageData('', language, {
    preview,
    data: previewData,
  });

  // console.log('tryGetPreviewData pageData11', pageData);
  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Sadhguru',
      isPreview: !!preview,
    },
  };
};

export default Sadhguru;
